import React from 'react';
import Loader from '../../assets/images/loading.gif';
import { Container } from './styles';

const Loading = () => <Container><img src={Loader} /></Container>

export default Loading;
